import React, { useState } from 'react'
import { Tooltip } from '@instructure/ui-tooltip'
import { Link } from '@instructure/ui-link'
import { TruncateText } from '@instructure/ui-truncate-text'
import { Text } from '@instructure/ui-text'
import { ScreenReaderContent } from '@instructure/ui-a11y-content'

const TruncateSection = (props) => {
  const {handleAddToSection, user, sect} = props
  const [isTruncated, setIsTruncated] = useState(false);

  const handleUpdate = (isThisTruncated) => {
    if (isTruncated !== isThisTruncated) {
      setIsTruncated(isThisTruncated)
    }
  }

  const renderLink = () => {
    return <Link onClick={(e) => handleAddToSection(e, user, sect)}>
      <ScreenReaderContent>
        Add to section
      </ScreenReaderContent>
      <TruncateText onUpdate={handleUpdate}>
        {sect.name}
      </TruncateText>
    </Link>
  }

  return (
      <Text size="x-small">
        {isTruncated ? (
            <Tooltip renderTip={sect.name || ""} placement="end">
              {renderLink()}
            </Tooltip>
        ) : renderLink()}
      </Text>
  )
}

export default TruncateSection